<template>
    <div>
            <label>Foto</label>
            <b-input-group>

                <div class="custom-file">
                    <input type="file" class="custom-file-input"
                           id="file" ref="file" @change="changeFileName()">
                    <label class="custom-file-label" for="file" >{{filename}}</label>
                </div>

            </b-input-group>

            <b-progress v-if="uploading" class="mt-1" :value="uploadPercentage" :max="'100'" animated></b-progress>

        <label class="mt-3">Foto 2</label>
        <b-input-group>
            
            <div class="custom-file">
                <input type="file" class="custom-file-input"
                       id="file_2" ref="file_2" @change="changeFileName_2()">
                <label class="custom-file-label" for="file_2" >{{filename_2}}</label>
            </div>
        
        </b-input-group>
        
        <b-progress v-if="uploading_2" class="mt-1" :value="uploadPercentage_2" :max="'100'" animated></b-progress>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "file-upload",
        props: {
            id: Number
        },
        data(){
            return {
                file: [],
                file_2: [],
                uploadPercentage: 0,
                uploadPercentage_2: 0,
                uploading: false,
                uploading_2: false
            }
        },
        methods: {
            changeFileName() {

                this.file = this.$refs.file.files[0];
                this.uploadFile();
            },
            changeFileName_2() {
        
                this.file_2 = this.$refs.file_2.files[0];
                this.uploadFile_2();
            },
            async uploadFile() {
                try {
                    this.uploading = true;

                    let formData = new FormData();

                    formData.append('file', this.file);
                    formData.append('id', this.id);
                    formData.append('db_table_column_name', 'img_url');

                    await axios.post( process.env.VUE_APP_SERVER+'file-upload/file-upload.php',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            onUploadProgress: function( progressEvent ) {
                                this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                            }.bind(this)
                        }
                    );

                    console.log('SUCCESS!!');
                    this.$emit('load-data');
                    this.file = [];
                    this.uploading = false;

                } catch (error) {
                    console.log('FAILURE!!'+error);
                }
            },
            async uploadFile_2() {
                try {
                    this.uploading_2 = true;
            
                    let formData = new FormData();
            
                    formData.append('file', this.file_2);
                    formData.append('id', this.id);
                    formData.append('db_table_column_name', 'img_url_2');
            
                    await axios.post( process.env.VUE_APP_SERVER+'file-upload/file-upload.php',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            onUploadProgress: function( progressEvent ) {
                                this.uploadPercentage_2 = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                            }.bind(this)
                        }
                    );
            
                    console.log('SUCCESS!!');
                    this.$emit('load-data');
                    this.file_2 = [];
                    this.uploading_2 = false;
            
                } catch (error) {
                    console.log('FAILURE!!'+error);
                }
            }
        },
        computed: {
            filename: function () {
                if (this.file.name) {
                    return this.file.name;
                } else {
                    return 'Vyber soubor';
                }
            },
            filename_2: function () {
                if (this.file_2.name) {
                    return this.file_2.name;
                } else {
                    return 'Vyber soubor';
                }
            }
        }
    }
</script>

<style scoped>

</style>